// extracted by mini-css-extract-plugin
export var infoItem = "_oy-2";
export var title = "_oy-0";
export var value = "_oy-1";